import { render, staticRenderFns } from "./controller.vue?vue&type=template&id=0cbe5a5a&scoped=true&"
import script from "./controller.vue?vue&type=script&lang=js&"
export * from "./controller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbe5a5a",
  null
  
)

export default component.exports